import { drupalComponent } from '@nech/src/helpers/drupal-component';
import { applyExternalLinkBehavior } from '@nech/src/helpers/external-links';

(function (Drupal, $) {
  drupalComponent('rich_text_module', {
    selector: '.rich_text_module',

    attach(context) {
      const $elements = $(this.selector, context);

      $elements.each(function () {
        const $module = $(this);
        const $richTextContainers = $module.find('.rich_text, .rich_text_image');

        $richTextContainers.each(function () {
          applyExternalLinkBehavior($(this));
        });
      });
    },
  });
})(Drupal, jQuery);
